import type { SVGProps } from 'react';
const SvgVkTypeLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <rect width={60} height={60} fill="#0F81FF" rx={8} />
    <path
      fill="#fff"
      d="M47.687 37.641c-.093-.156-.67-1.408-3.443-3.982-2.903-2.695-2.513-2.258.984-6.918 2.13-2.839 2.981-4.572 2.715-5.313-.254-.706-1.82-.52-1.82-.52l-5.209.03s-.386-.052-.674.12c-.28.169-.459.558-.459.558s-.825 2.198-1.926 4.065c-2.32 3.941-3.25 4.15-3.63 3.904-.881-.57-.66-2.292-.66-3.514 0-3.82.578-5.412-1.129-5.824-.568-.136-.984-.227-2.433-.242-1.86-.02-3.434.006-4.325.442-.594.29-1.05.938-.771.975.344.045 1.124.21 1.538.773.535.726.516 2.36.516 2.36s.308 4.495-.717 5.054c-.704.384-1.669-.398-3.738-3.976-1.06-1.83-1.861-3.856-1.861-3.856s-.154-.377-.429-.579c-.334-.245-.802-.323-.802-.323l-4.953.03s-.743.022-1.016.345c-.242.288-.02.882-.02.882s3.879 9.072 8.269 13.646c4.028 4.192 8.6 3.917 8.6 3.917h2.07s.627-.07.945-.414c.295-.316.284-.91.284-.91s-.041-2.78 1.25-3.189c1.272-.403 2.906 2.687 4.637 3.876 1.309.9 2.303.702 2.303.702l4.63-.065s2.423-.15 1.274-2.054"
    />
  </svg>
);
export default SvgVkTypeLarge;
